module.exports = __webpack_public_path__ + "img/poor6.43fa79db.png";